<template>
<div>
  <div :style="($ml.current === 'EN') ? 'display:block;' : 'display:none;'" >
    <vue-markdown style="overflow: auto;" @rendered="onrendered">

  List of possible options to be passed to "configuration" object, according to your needs:

  ``` javascript
  var configQuanteec = {
      quanteecKey: "myquanteecKey", // [Mandatory] String --> used to verify the authorizations
      videoID: "videoID", // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
      activated: true, // [Optionnel] Boolean --> Activate/deactivate Quanteec, including the connection with the controller. This value overrides p2p.activated which does not stop the connection to the controller. Default : true
      withCredentials: true, // [Optional] Boolean --> sends the HTTP requests with credentials. Default: false.
      externalLive: true, // [Optional] Boolean --> used for detection of live interruption, by activating error detection.
      analytics: {
          analyticsVideoID: 'videoID',   // [Optional] String --> specific name to identify a video for the Analytics process. Default, videoID is used.
      },
      p2p: {
          activated: true, // [Optional] Boolean --> Activates QUANTEEC P2P system. Default: true
          maxUploadPercent: 0.5 // [Optionnel] Number --> Percentage of upload to use. Number between 0 and 1. If 0, nothing is sent, but the peer still receives data. Default: 0.5
          tracker: "wss://tracker_url" // [Optional] String --> URL of the tracker. Used only in specific scenarios where the signalling server is deployed on premise.
      }
  };
  ```
  [Contact us](mailto:support@quanteec.com) if you need some specific options.
      </vue-markdown>
  </div>
  <div :style="($ml.current === 'FR') ? 'display:block;' : 'display:none;'">
    <vue-markdown style="overflow: auto;" @rendered="onrendered">

Liste des options à passer dans l'objet **configuration**, selon vos besoins :

``` javascript
var configQuanteec = {
    quanteecKey: "myquanteecKey", // [Obligatoire] String --> utilisé pour vérifier les autorisations
    videoID: "videoID",// [Optionnel mais recommandé] String --> Nom spécifique pour identifier une vidéo. Important si l'url de la source contiens un token qui peut être différent pour chaque utilisateurs. Par défaut : l'url de la vidéo est utilisé.
    activated: true, // [Optionnel] Boolean --> Active ou désactive Quanteec, y compris la connexion avec le controller. Cette valeur écrase p2p.activated qui ne désactive que le controller. Par défaut : true
    withCredentials: true, // [Optionnel] Boolean --> Inclus les credentials dans les requêtes HTTP. Par défaut : false
    externalLive: true, // [Optionnel] Boolean --> utilisé pour détecter l'interruption des diffusions en direct.
    analytics: {
        analyticsVideoID: 'videoID',   // [Optionnel] String --> Nom spécifique utilisé pour identifier une vidéo dans les Analytics. Par défaut, le videoID est utilisé.
    },
    p2p: {
        activated: true, // [Optionnel] Boolean --> Active le système pair-à-pair de QUANTEEC. Par défaut: true
        maxUploadPercent: 0.5 // [Optionnel] Number --> Définit le pourcentage de la valeur d'upload mesurée à utiliser. Nombre entre 0 et 1. Si 0, rien n'est envoyé, mais le pair peut continuer à recevoir. Par défaut: 0.5
        tracker: "wss://tracker_url" // [Optionnel] String --> URL du tracker. Utilisé uniquement dans des scénarios spécifiques où le serveur de signalling est déployé sur site client.
    }
};
```
[Contactez nous](mailto:support@quanteec.com) si vous avez besoin d'options spécifiques.
    </vue-markdown>
  </div>








<h4>API Javascript :</h4>

<div :style="($ml.current === 'EN') ? 'display:block;' : 'display:none;'" >
    <vue-markdown style="overflow: auto;" @rendered="onrendered">

  

  ``` javascript
  quanteecPlayer.activateQuanteec(true); // Activate Quanteec and mesh-delivery
  quanteecPlayer.activateQuanteec(false); // Deactivate Quanteec and mesh-delivery. All connections to the controller will be stopped.

  quanteecPlayer.activateP2P(true); // Activate mesh-delivery 
  quanteecPlayer.activateP2P(false); // Deactivate  mesh-delivery

  greenScore = quanteecPlayer.getGreenScore() // Return the green score, the data in p2p divided by the data in http

  energy = quanteecPlayer.getEnergySavedInWh() // Return the total energy saved in Wh
  energy = quanteecPlayer.getEnergySavedReceivedInWh() // Return the energy saved by the data received in Wh
  energy = quanteecPlayer.getEnergySavedSentInWh() // Return the energy saved by the data sent in Wh
  energy = quanteecPlayer.getEnergySavedInLight() // Return the energy saved in lights switched on during 5 minutes
  energy = quanteecPlayer.getEnergySavedInCO2g() // Return the energy saved in g of CO2
  energy = quanteecPlayer.getEnergySavedInWatercL() // Return the energy saved in cL of water

  quanteecPlayer.setMaxUploadPercent(value) // Define the maximum percentage of upload bandwidth to use, between 0 and 1. At 0, the peer does not send anything, but can receive data.
  ```
  [Contact us](mailto:support@quanteec.com) if you need some specific functions.
      </vue-markdown>
  </div>
  <div :style="($ml.current === 'FR') ? 'display:block;' : 'display:none;'">
    <vue-markdown style="overflow: auto;" @rendered="onrendered">

    

    ``` javascript
    quanteecPlayer.activateQuanteec(true); // Activer Quanteec et la distribution en pair-à-pair 
    quanteecPlayer.activateQuanteec(false); // Désactiver Quanteec et la distribution en pair-à-pair  

    quanteecPlayer.activateP2P(true); // Activer la diffusion en pair-à-pair
    quanteecPlayer.activateP2P(false); // Désactiver la diffusion en pair-à-pair

    greenScore = quanteecPlayer.getGreenScore() // Retourne le green score, le rapport des données en p2p sur les données reçues en HTTP

    energy = quanteecPlayer.getEnergySavedInWh() // Retourne l'énergie économisée totale en Wh
    energy = quanteecPlayer.getEnergySavedReceivedInWh() // Retourne l'énergie économisée par les données reçues en Wh
    energy = quanteecPlayer.getEnergySavedSentInWh() // Retourne l'énergie économisée par les données envoyées en Wh
    energy = quanteecPlayer.getEnergySavedInLight() // Retourne l'énergie économisée par rapport à une ampoule allumée 5 minutes
    energy = quanteecPlayer.getEnergySavedInCO2g() // Retourne l'énergie économisée en g de CO2
    energy = quanteecPlayer.getEnergySavedInWatercL() // Retourne l'énergie économisée en cL d'eau

    quanteecPlayer.setMaxUploadPercent(value) // Définit le pourcentage maximum de la bande-passante montante mesurée à utiliser, entre 0 et 1. À 0, le pair n'envoie rien, mais peut recevoir.
    ```
    [Contactez nous](mailto:support@quanteec.com) si vous avez besoin de fonctions spécifiques.
    </vue-markdown>
  </div>


</div>
</template>
<script>
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'ConfigDoc',
  data: function() {
    return {
     
    }
  },
  components: {
      VueMarkdown
  },
  mounted: function() {
 
  },
  methods: {
     onrendered() {
        Prism.highlightAll()
     }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>